import Vue from 'vue'
import {mapGetters} from 'vuex'

import FaresService from 'js/services/api/downloadable-resources/fares.js'
import SchedulesService from 'js/services/api/downloadable-resources/schedules.js'

import DownloadFileMixin from 'js/mixins/download-file.js'

import DownloadableResource from 'js/components/downloadable-resource'

import imageNoFares from 'assets/images/ilustrations/private-area/no-fares.svg'
import imageNoSchedules from 'assets/images/ilustrations/private-area/no-schedules.svg'

import imageFare from 'assets/images/ilustrations/private-area/fares.svg'
import imageSchedule from 'assets/images/ilustrations/private-area/schedules.svg'

import template from './index.pug'

const RESOURCE_CONFIGS = {
  fares: {
    image: imageFare,
    service: FaresService,
    emptyImage: imageNoFares
  },
  schedules: {
    image: imageSchedule,
    service: SchedulesService,
    emptyImage: imageNoSchedules
  }
}

// @vue/component
export default Vue.extend({
  name: 'downloadable-resources',
  template: template(),

  components: {DownloadableResource},

  mixins: [DownloadFileMixin],

  props: {
    type: {
      type: String,
      required: true,
      validator: type => {
        const availableTypes = Object.keys(RESOURCE_CONFIGS)

        return availableTypes.includes(type)
      }
    }
  },

  data() {
    return {
      resources: [],
      downloadError: false
    }
  },

  computed: {
    ...mapGetters('runtimeConfig', ['apiHost']),

    emptyStateImage() {
      return this.resourceConfig.emptyImage
    },

    hasResources() {
      return this.resources.length > 0
    },

    resourceConfig() {
      return RESOURCE_CONFIGS[this.type]
    },

    image() {
      return this.resourceConfig.image
    },

    service() {
      return this.resourceConfig.service
    }
  },

  watch: {
    currentMunicipality() {
      this.loadResources()
    },

    type() {
      this.loadResources()
    },

    downloadError(newValue){
      if(newValue){
        this.sendNotificationFormErrors()
      }
    }
  },

  created() {
    if (this.currentMunicipality.id) this.loadResources()
  },

  methods: {
    async loadResources() {
      const params = {
        municipality_id: this.currentMunicipality.id,
        caducity_from: moment().format(),
        order_by: 'order',
        order_dir: 'asc',
        per: 0
      }

      this.resources = await this.service.index(params)
    },

    resourceId(resource) {
      return `resource_${resource.id}`
    },

    download(resource) {
      const url = `${this.apiHost}/downloadable_resource/${this.type}/${resource.id}/download_file`
      const filename = `${resource.name}.pdf`

      this.testUrl(url).then(result => {
        if(result){
          this.downloadFile(url, filename, true)
        }
      })
    },

    sendNotificationFormErrors() {
      this.$notifications.send({
        id: 'schedule-download-errors',
        text: this.$t('routes.button.downloadError'),
        type: 'error',
        close: true
      })
    },
  }
})
